import { languageMap } from ".."

languageMap.arff = {
	comments: {
		line: "%",
	},
}
